import styled from "styled-components";

const StyledBubble = styled.svg.attrs({
  viewbox: "0px 0px 18px 16px",
})`
  width: 18px;
  height: 16px;
  fill: none;
`;

export default StyledBubble;
